import $ from 'jquery';
import { isNil } from 'lodash';
import { localNumberData } from '../_helpers/constants';

export default class LocalNumber {
  constructor(element) {
    this.item = $(element)[0];
  }

  initItem(el) {
    const rawNumber = $(el).data(localNumberData);
    if (isNil(rawNumber)) {
      return;
    }
    const formatter = new Intl.NumberFormat(undefined);
    const value = formatter.format(rawNumber);
    $(el).text(value);
  }

  init() {
    this.initItem(this.item);
  }
}
